import React, { Component } from "react";
import { HomeHeaderBody, AntdPopoverStyle } from "./style";
import { colorPalette } from "../../color-palette";
import { RouteComponentProps, Link, NavLink } from "react-router-dom";
import { Popover, Switch, Icon } from "antd";
import { withContext } from "../../contexts";
import { UserContext, UserState } from "../../contexts/user";
// tslint:disable:jsx-wrap-multiline jsx-alignment jsx-no-multiline-js
type Hprops= {
  children: React.ReactNode;
} & RouteComponentProps & UserState;
interface Hstate {}
/**
 * 大屏导航页面
 * @author 马俊峰
 * @date 2020-07-29
 * @class HomeHeader
 * @extends {Component<Hprops, Hstate>}
 */
class HomeHeader extends Component<Hprops, Hstate> {
  /** 倒计时退出登录 */
  clearTime: number | null = null;
  /** 全局dom实例 */
  rootDom: HTMLElement | null = null;
  render() {
    return(
      <HomeHeaderBody colorPalette={colorPalette}>
        <AntdPopoverStyle colorPalette={colorPalette} />
        <div className="menu-box">
          <Popover
            content={this.popoverMenuRender()}
            title={false}
            trigger="hover"
            placement="bottomLeft"
            overlayClassName="andhome-popover"
          >
            <span className="menu-icon" />
          </Popover>
        </div>
        <div className="content-body">{this.props.children}</div>
      </HomeHeaderBody>
    );
  }
  /** 导航菜单dom */
  popoverMenuRender = () => {
    const { user, logout } = this.props;
    return <div className="popover-box">
     <div className="pb-title">领导视窗</div>
     <div className="router-box">
       <NavLink to="/big-screen" className="route-item" activeClassName="r-active">农业遥感监测可视化平台</NavLink>
       <NavLink to="/village-screen" className="route-item" activeClassName="r-active">农村遥感监测可视化平台</NavLink>
     </div>
     <div className="timing-function">
       <span className="tf-label">定时登录</span>
       <Switch
          checkedChildren={<Icon type="check" />}
          unCheckedChildren={<Icon type="close" />}
          defaultChecked={false}
          size="small"
          onChange={this.switchIconRender}
        />
     </div>
     <div className="user-box">
        <span className="user-name">{user && user.name || "***"}</span>
        <span className="logout-box" onClick={this.logoutClick}>
          <Icon type="poweroff" />
          <span className="logout-value">退出</span>
        </span>
     </div>
    </div>;
  }
  componentDidMount() {
    this.rootDom = document.getElementsByTagName("body")[0] as HTMLElement;
  }
  /** 定时登录事件 */
  switchIconRender = (checked: boolean) => {
    if (checked) { this.bodyListenerEvent(); } else {
      this.removeEvent();
    }
  }
  /** 清除监听事件 */
  removeEvent = () => {
    this.rootDom && this.rootDom.removeEventListener("mousemove", this.regularLogin);
    this.clearTime && clearTimeout(this.clearTime);
  }
  /** 事件监听，清除登录功能 */
  bodyListenerEvent = () => {
    this.regularLogin();
    this.rootDom && this.rootDom.addEventListener("mousemove", this.regularLogin);
  }
  /** 定时退出登录事件 */
  regularLogin = () => {
    this.clearTime && clearTimeout(this.clearTime);
    this.clearTime = setTimeout(() => { this.props.logout(); }, 1000 * 60 * 10);
  }
  componentWillUnmount() {
    this.removeEvent();
  }
  /** 手动退出登录事件 */
  logoutClick = () => {
    this.props.logout();
    this.props.history.replace("/");
  }
}
export default withContext(UserContext)(HomeHeader);
